/* eslint-disable */
import { useEffect, useState, useContext, useMemo } from "react";

// material react table
import { MaterialReactTable } from "material-react-table";

/* importing all survey data */
// import surveyData from 'data/AllSurveyData.json';

//import translation function for language translation
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

const AllReserveSurveyPopup = () => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation

  const {
    reservePersonData,
    setReservePersonData,
    setReserveSurveyData,
    screenHeight,
  } = useContext(GlobalProvider);

  const [surveyList, setSurveyList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);

  //function for get all survey list
  const getAllSurveyList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_SURVEY_FEEDBACK +
        `?token=${token}&user=${reservePersonData.surveyPerson._id}&reservation=${reservePersonData.reserveEvent}&customreserveid=${reservePersonData.reserveid}`;

      const response = await getData(requestUrl);

      console.log("Response in survey list=======>", response);

      if (response.status) {
        setSurveyList(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* custom action HTML */
  const ActionHTML = ({ dataItem }) => {
    return (
      <div className="action">
        <Link
          to="#view_reserve_survey_feedback_popup"
          data-bs-toggle="offcanvas"
          role="button"
          aria-controls="viewFeedbackPopup"
          className="btn btn-outline-primary btn-sm mw-unset"
          onClick={() => {
            setReserveSurveyData(dataItem);
          }}
        >
          {t("Details")}
        </Link>
      </div>
    );
  };

  //surve response HTML
  const surveyResponseHTML = ({ dataItem }) => {
    return (
      <div className="action">
        <p>{dataItem.surveyresponsestatus == "1" ? "Submitted" : "Pending"}</p>
      </div>
    );
  };

  //function for close button
  const resetHandler = () => {
    //setReservePersonData(null);
  };

  const tableColumns = useMemo(() => [
    {
      id: "surveydate",
      accessorKey: "surveydate",
      header: t("Date"),
      size: 200,
    },
    {
      id: "survey.name",
      accessorKey: "survey.name",
      header: t("Survey"),
      size: 200,
    },
    {
      id: "surveyresponsestatus",
      accessorKey: "surveyresponsestatus",
      header: t("Status"),
      Cell: ({ row }) => surveyResponseHTML({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "Action",
      accessorKey: "Action",
      header: t("Action"),
      Cell: ({ row }) => ActionHTML({ dataItem: row.original }),
      size: 200,
    },
  ], []);

  useEffect(() => {
    if (reservePersonData) {
      getAllSurveyList();
    }
  }, [reservePersonData, responseReceived]);

  return (
    <div
      className="offcanvas offcanvas-end border-0"
      tabIndex="-1"
      id="allReserveSurveyPopup"
      aria-labelledby="allReserveSurveyPopupLabel"
    >
      <div className="offcanvas-header p-4">
        <h3 className="text-secondary mb-0" id="allSurveyPopupLabel">
          {t("All Survey")}
        </h3>
        <button
          type="button"
          id="closeCreateMail"
          className="btn-close p-2 bg-white shadow-none shadow-sm m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4 pt-0">
        <div className="table-responsive">
          <MaterialReactTable
            columns={tableColumns}
            data={surveyList}
            enableSorting
            enableFilters
            enableGlobalFilter={false}
            enableColumnOrdering
            enableStickyHeader
            muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
            muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
            muiTableBodyProps={{ sx: { overflow: "visible" } }}
            initialState={{
              pagination: { pageSize: 100, pageIndex: 0 },
              showColumnFilters: true,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AllReserveSurveyPopup;
